  (function() {
    if (window.__productCardBound) return;
    window.__productCardBound = true;

    function updateCartCount(count) {
      document.querySelectorAll('.header__cart-count').forEach(function(el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
      // Si le compteur n'existait pas (panier vide au chargement), on le cree
      if (count > 0) {
        document.querySelectorAll('.header__icon--cart').forEach(function(btn) {
          if (!btn.querySelector('.header__cart-count')) {
            var span = document.createElement('span');
            span.className = 'header__cart-count';
            span.textContent = count;
            btn.appendChild(span);
          }
        });
      }
    }

    function setButtonState(btn, state, label) {
      btn.classList.remove('is-loading', 'is-success', 'is-error');
      if (state) btn.classList.add('is-' + state);
      if (label != null) {
        var labelEl = btn.querySelector('[data-card-cta-label]');
        if (labelEl) labelEl.textContent = label;
      }
    }

    function i18nFor(el, key) {
      var card = el && el.closest ? el.closest('.product-card') : null;
      return (card && card.getAttribute('data-i18n-' + key)) || '';
    }

    // Select change -> update displayed price on the card button
    document.addEventListener('change', function(e) {
      var select = e.target.closest('[data-card-variant-select]');
      if (!select) return;
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var form = select.closest('[data-card-form]');
      if (!form) return;
      var priceEl = form.querySelector('[data-card-cta-price]');
      var priceHtml = opt.getAttribute('data-price-html');
      if (priceEl && priceHtml) priceEl.textContent = priceHtml;
      var compareEl = form.querySelector('[data-card-cta-compare]');
      if (compareEl) compareEl.textContent = opt.getAttribute('data-compare-price-html') || '';
      var btn = form.querySelector('[data-card-cta]');
      if (btn) {
        var available = opt.getAttribute('data-available') === 'true';
        btn.disabled = !available;
        setButtonState(btn, null, available ? i18nFor(btn, 'add') : i18nFor(btn, 'sold-out'));
      }
    });

    // Form submit -> fetch /cart/add.js
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('[data-card-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-card-cta]');
      if (!btn || btn.disabled) return;
      var originalLabel = (btn.querySelector('[data-card-cta-label]') || {}).textContent || i18nFor(btn, 'add');

      setButtonState(btn, 'loading', i18nFor(btn, 'adding'));
      btn.disabled = true;

      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function(r) {
          if (!r.ok) return r.json().then(function(d) { throw d; });
          return r.json();
        })
        .then(function() {
          return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
            .then(function(r) { return r.json(); });
        })
        .then(function(cart) {
          updateCartCount(cart.item_count);
          setButtonState(btn, 'success', i18nFor(btn, 'added'));
          // Notify developly-cart to refresh its contents if present
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          setTimeout(function() {
            if (window.developlyCart && typeof window.developlyCart.open === 'function') {
              window.developlyCart.open();
            }
          }, 200);
          setTimeout(function() {
            setButtonState(btn, null, originalLabel);
            btn.disabled = false;
          }, 1500);
        })
        .catch(function(err) {
          console.error('[product-card] add-to-cart failed', err);
          var fallback = i18nFor(btn, 'error');
          /* 2026-10-15 (QW5) : plus de message technique du navigateur (« Failed to fetch ») ; seulement
             la raison donnee par Shopify si elle tient dans le bouton, sinon le texte traduit. */
          var msg = (err && err.description) || fallback;
          setButtonState(btn, 'error', msg.length > 20 ? fallback : msg);
          setTimeout(function() {
            setButtonState(btn, null, originalLabel);
            btn.disabled = false;
          }, 2500);
        });
    });
  })();
